import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Switch, Select, InputNumber, Checkbox } from 'antd'
import { CaretLeft, Plus } from '@phosphor-icons/react'
import './styles/manage-tickets.scss'

import TicketRow from './essentialComponents/TicketRow'
import LateFeeRow from './essentialComponents/LateFeeRow'
import DropInTicketRow from './essentialComponents/DropInTicketRow'
import Discounts from './essentialComponents/Discounts'
import DiscountCode from './Modals/Discount/DiscountCode'

import { classesEventStore } from 'state/classes/classesStore'
import { useGetClassesDiscountCode } from 'api/Classes/Step6Tickets/Tickets'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { infoMessage } from 'api/global'

const { Option } = Select

const ManageTickets = ({ handleNext, handleBack }: any) => {
  const classesData = classesEventStore(store => store.classesData) as any
  const setClassesData = classesEventStore(store => store.setClassesData)
  const { _id } = classesData || {}

  const [isRecurringPayment, setIsRecurringPayment] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [discountModalOpen, setDiscountModalOpen] = useState(false)
  const [selectedDiscountData, setSelectedDiscountData] = useState<any>(null)

  const [selectedFrequency, setSelectedFrequency] = useState<string | undefined>()

  const [tempFrequency, setTempFrequency] = useState<string>('daily')
  const [interval, setIntervalValue] = useState<number>(1)

  const [selectedDayOfMonth, setSelectedDayOfMonth] = useState<number[]>([])
  const [selectedMonthOfYear, setSelectedMonthOfYear] = useState<string[]>([])
  const [selectedDayOfWeek, setSelectedDayOfWeek] = useState<string[]>([])

  const [enableMonthSelection, setEnableMonthSelection] = useState(false)
  const [enableYearSelection, setEnableYearSelection] = useState(false)
  const [enableWeekSelection, setEnableWeekSelection] = useState(false)

  const [selectedWeekOfMonth, setSelectedWeekOfMonth] = useState<string>('First')
  const [specificDayOfWeek, setSpecificDayOfWeek] = useState<string>('Monday')

  const [draftState, setDraftState] = useState<any>(null)

  const dayss = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const weekOptions = ['First', 'Second', 'Third', 'Fourth', 'Last']
  const dayOfWeekOptions = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ]

  const handleSwitchChange = (checked: boolean) => {
    setIsRecurringPayment(checked)

    if (!checked) {
      setSelectedFrequency(undefined)
      setTempFrequency('daily')
      setIntervalValue(1)
      setSelectedDayOfWeek([])
      setSelectedDayOfMonth([])
      setSelectedMonthOfYear([])
      setEnableMonthSelection(false)
      setEnableYearSelection(false)
      setEnableWeekSelection(false)
    }
  }

  const handleApply = () => {
    let displayValue = ''

    if (tempFrequency === 'daily') {
      displayValue = `Every ${interval} day${interval > 1 ? 's' : ''}`
    }

    if (tempFrequency === 'weekly') {
      const days = selectedDayOfWeek.join(', ')
      displayValue = `Every ${interval} week${interval > 1 ? 's' : ''}${days ? ` on ${days}` : ''}`
    }

    if (tempFrequency === 'monthly') {
      if (enableMonthSelection) {
        displayValue = `Every ${interval} month${interval > 1 ? 's' : ''} on day ${selectedDayOfMonth.join(', ')}`
      } else if (enableWeekSelection) {
        displayValue = `Every ${interval} month${interval > 1 ? 's' : ''} on the ${selectedWeekOfMonth} ${specificDayOfWeek}`
      } else {
        displayValue = `Every ${interval} month${interval > 1 ? 's' : ''}`
      }
    }

    if (tempFrequency === 'yearly') {
      if (enableYearSelection && enableWeekSelection) {
        displayValue = `Every ${interval} year${interval > 1 ? 's' : ''} on the ${selectedWeekOfMonth} ${specificDayOfWeek} in ${selectedMonthOfYear.join(', ')}`
      } else if (enableYearSelection) {
        displayValue = `Every ${interval} year${interval > 1 ? 's' : ''} in ${selectedMonthOfYear.join(', ')}`
      } else {
        displayValue = `Every ${interval} year${interval > 1 ? 's' : ''}`
      }
    }

    setSelectedFrequency(displayValue)
    setIsDropdownOpen(false)
  }

  const handleCancel = () => {
    if (draftState) {
      Object.keys(draftState).forEach(key => {
        ;(eval(`set${key[0].toUpperCase() + key.slice(1)}`) as any)(
          draftState[key]
        )
      })
    }

    setIsDropdownOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = () => {
      if (isDropdownOpen) handleCancel()
    }

    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [isDropdownOpen])

  const {
    data: discountCodesData,
    isLoading: discountCodeLoading,
    isFetching: discountCodeFetching,
    refetch: discountCodeRefetch
  } = useGetClassesDiscountCode(_id)

  useEffect(() => {
    discountCodeRefetch()
  }, [])

  return (
    <div className="step4-main-container">
      <div className="content scroller overflow-auto-y">
        <h3 className="text-24 w-600">Step 6. Manage Tickets</h3>

        {/* Recurring Payment */}
        <div className="mt-30px">
          <div className="flex align-center justify-between">
            <p className="text-16 w-600">Recurring payment</p>
            <Switch
              checked={isRecurringPayment}
              onChange={handleSwitchChange}
            />
          </div>

          {isRecurringPayment && (
            <div className="recurring-payment-card mt-20px">
              <label className="input-label text-12 w-600">
                Frequency
              </label>

              {/* Frequency Select */}
              <Select
                className="recurring-select w-full"
                placeholder="Select"
                value={selectedFrequency}
                open={isDropdownOpen}
                dropdownMatchSelectWidth={false}
                onClick={(e) => {
                  e.stopPropagation()

                  setDraftState({
                    tempFrequency,
                    interval,
                    selectedDayOfWeek,
                    selectedDayOfMonth,
                    selectedMonthOfYear,
                    enableMonthSelection,
                    enableYearSelection,
                    enableWeekSelection,
                    selectedWeekOfMonth,
                    specificDayOfWeek
                  })

                  setIsDropdownOpen(true)
                }}
                dropdownRender={() => (
                  <div
                    className="recurring-dropdown"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* Frequency */}
                    <div className="field flex align-center gap-10">
                      <label className="frequency-title">
                        Frequency
                      </label>

                      <Select
                        value={tempFrequency}
                        onChange={setTempFrequency}
                        className="inner-select"
                      >
                        <Option value="daily">Daily</Option>
                        <Option value="weekly">Weekly</Option>
                        <Option value="monthly">Monthly</Option>
                        <Option value="yearly">Yearly</Option>
                      </Select>
                    </div>

                    {/* Interval */}
                    <div className="field flex align-center gap-10">
                      <span className="frequency-title">
                        Every
                      </span>

                      <InputNumber
                        min={1}
                        value={interval}
                        onChange={(v) =>
                          setIntervalValue(v || 1)
                        }
                      />

                      <span className="frequency-title">
                        {tempFrequency}
                        {interval > 1 ? 's' : ''}
                      </span>
                    </div>

                    {/* Weekly */}
                    {tempFrequency === 'weekly' && (
                      <div className="field">
                        <label>Select days</label>

                        <div className="days">
                          {dayss.map(day => (
                            <div
                              key={day}
                              className={`pill ${
                                selectedDayOfWeek.includes(day)
                                  ? 'active-week-day'
                                  : ''
                              }`}
                              onClick={() =>
                                setSelectedDayOfWeek(prev =>
                                  prev.includes(day)
                                    ? prev.filter(
                                        d => d !== day
                                      )
                                    : [...prev, day]
                                )
                              }
                            >
                              {day}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Footer */}
                    <div className="footer">
                      <Button onClick={handleCancel}>
                        Cancel
                      </Button>

                      <Button
                        type="primary"
                        onClick={handleApply}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                )}
              />
            </div>
          )}
        </div>

        {/* Tickets */}
        <TicketRow type="admission" />
        <TicketRow type="additional" />
        <DropInTicketRow />
        <LateFeeRow />

        {/* Discount */}
        <div className="mt-20px">
          <div className="flex align-center justify-between">
            <p className="text-16 w-600">
              Discount codes
            </p>

            <div
              className="w-36px h-36px radius-rounded bg-blue flex align-center justify-center pointer"
              onClick={() => {
                if (
                  !classesData?.admissionTickets ||
                  classesData.admissionTickets.length === 0
                ) {
                  return infoMessage(
                    'First create admission ticket'
                  )
                }

                setSelectedDiscountData(null)
                setDiscountModalOpen(true)
              }}
            >
              <Plus size={12} color="#fff" />
            </div>
          </div>
        </div>

        {discountCodeLoading ||
        discountCodeFetching ? (
          <div className="flex justify-center py-30px">
            <ButtonSpinner size={30} color='#000'  />
          </div>
        ) : (
          <Discounts
            data={Array.isArray(discountCodesData) ? discountCodesData : discountCodesData?.discountCodes || []}
            discountModalOpen={discountModalOpen}
            setDiscountModalOpen={setDiscountModalOpen}
            selectedDiscountData={selectedDiscountData}
            setSelectedDiscountData={setSelectedDiscountData}
          />
        )}
      </div>

      {/* Footer */}
      <div className="mt-15px event-button-cont">
        <h5 onClick={handleBack}>
          <CaretLeft size={20} /> Back
        </h5>

        <Button onClick={handleNext}>
          Next
        </Button>
      </div>

      {/* Modal */}
      {discountModalOpen && (
        <DiscountCode
          modalOpen={discountModalOpen}
          modalClose={setDiscountModalOpen}
          data={selectedDiscountData}
        />
      )}
    </div>
  )
}

export default ManageTickets

